import { useState } from "react";
import FormComp from "../../../Componentes/FormComp";
import Overlay from "../../../Componentes/Overlay";
import Formulario from "../../../Componentes/Utils/Formulario";
import Modal from "../../../Componentes/Utils/Modal";
import { useModal } from "../../../contexts/ModalContext";
import axios from "axios";
import SmallLoading from "../../../Componentes/Utils/SmallLoading";

const ModalNovaCategoria = ({ updateCategorias }) => {

    const { closeModal } = useModal();

    const [loading, setLoading] = useState(false);
    const [categoria, setCategoria] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();

        setLoading(true);

        try {

            const formData = new FormData();
            formData.append("categoria", categoria);

            await axios.post("https://sistemaintegrado.palmont.com.br/Painel/API/Desvios/NovaCategoria/", formData);
            await updateCategorias();
            closeModal();

        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }

    }

    return (
        <>
            <Overlay state={true} >
                <Modal header close={closeModal} >
                    <Formulario onSubmit={handleSubmit} >
                        <FormComp
                            title="CATEGORIA"
                            type="text"
                            placeholder="DIGITE..."
                            valor={categoria}
                            changeFunc={(e) => setCategoria(e.target.value.toUpperCase())}
                        />
                        <FormComp
                            valor="SALVAR"
                            type="submit"
                        />
                    </Formulario>
                </Modal>
                {
                    loading && (
                        <Overlay state={true}>
                            <Modal size="sm" >
                                <SmallLoading />
                            </Modal>
                        </Overlay>

                    )
                }
            </Overlay>
        </>
    )
}

export default ModalNovaCategoria;